<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    authorizedUserID() {
      return this.$store.state.authentication.userId;
    },
    currentDomainID() {
      return this.$store.getters['domain/getCurrentDomainID'];
    },
    currentPermissions() {
      return this.$store.getters.permissions;
    }
  },
  watch: {
    authorizedUserID(newUserID) {
      this.onAuthorizedUserIDChanged(newUserID);
    },
    currentDomainID(newID) {
      if (newID) {
        const { fullPath } = this.$route;
        const { refreshOnDomainChange } = this.$route.meta;
        if (refreshOnDomainChange) {
          this.$router.replace({ path: '/redirect' + fullPath });
        }
      }
    },
    currentPermissions(newPermissions, oldPermissions) {
      // Generate routes for side bar
      this.$store.dispatch('permission/generateRoutes', newPermissions);
    }
  },
  mounted() {
    this.setBackgroundImage();
  },
  created() {
    this.$i18n.locale = this.$store.getters.language;
    this.onAuthorizedUserIDChanged(this.authorizedUserID);
  },
  methods: {
    onAuthorizedUserIDChanged(newUserID) {
      if (newUserID) {
        this.$store.dispatch('option/fetchAllOptions');
        this.$store.dispatch('configuration/getItems');
        // Load linked domains
        this.$store
          .dispatch('getUserInfo', {
            withDomains: true
          })
          .then(() => {
            const domains = this.$store.state.authentication.domains;
            const currentDomainIsInlist = domains.some(e => e.id === this.currentDomainID);
            if (domains.length === 0) {
              this.$store.dispatch('domain/clearCurrentDomainID');
            } else if (domains.length && !currentDomainIsInlist) {
              // select all domains of all companies to which the user is linked
              if (domains.length > 1) {
                this.$store.dispatch('domain/selectAllDomains');
              } else {
                // domains.length === 1
                this.$store.dispatch('domain/setCurrentDomainID', domains[0].id);
              }
            }
          });
      }
    },
    setBackgroundImage() {
      const apiUrl = window.API_URL;
      if (apiUrl && apiUrl !== 'https://api.webatelier.nl/api') {
        document.body.style.backgroundImage = 'url("project-bg-development.png")';
      }
    }
  }
};
</script>
